export const colorScheme = ['primary', 'secondary', 'tertiary', 'accent']

export const randomColorString = (prefix='', suffix='') => {
  return `${prefix}${colorScheme[Math.floor(Math.random() * colorScheme.length)]}${suffix}`
}

export const shortDate = (date) => {
  let d = new Date(date)
  return d.toLocaleDateString()
}